import React, { useState} from 'react';
import { 
  Alert,
  Spinner,
  FormGroup,
  Form,
  Button,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
  Row,
  Col,
  Label,
  Popover,
  PopoverBody
} from 'reactstrap';
import { FormWrapperForm, InputView } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faUser,
  faFemale,
  faEnvelope,
  faIdCard,
  faCalendar,
  faWrench,
  faPhone,
  faQuestionCircle
} from '@fortawesome/free-solid-svg-icons'
import api from '../../services/client/api';
import { useHistory } from 'react-router-dom';
import cookie from '../../services/cookie/index';
import {deleteCookies} from '../../utils/functions';

export default function UpdateUser({userID, Name, CodPatient, CPF, MotherName, Birthday, Tel, Email, Categoria}) {


  const [inProgress, setInProgress] = useState(false);
  const [error, setError] = useState(false);
  
  const [fields, setFields] = useState({
    id_user: userID,
    name: Name,
    cpf: CPF,
    mother_name: MotherName,
    birthday: Birthday,
    tel: Tel,
    email: Email,
    code_patient: CodPatient
  });
  const [msgError, setMsgError] = useState('erro');
  const history = useHistory();
const [popoverOpen, setPopoverOpen] = useState(false);
const abrirPopover = () => setPopoverOpen(true);
const fecharPopover = () => setPopoverOpen(false);

function formatBirthday(dateBR) {
  const [dia, mes, ano] = dateBR.split('/');
  return `${ano}-${mes}-${dia}T00:00:00Z`;
}

  const create = async (e) => {

    e.preventDefault();
    setInProgress(true);
    const username = await cookie().get("username");
    const token = await cookie().get("tokenAdm")
   
    const body = {
      ...fields,
      birthday: formatBirthday(fields.birthday),
      username: username,
      id_categoria: Categoria
    };
  
    
  const response = await api().userPatient().update(token, body);


    if (response.status === 401) 
    {
      await deleteCookies();
      return history.push({ pathname:"/admin"});
    } 
    
    if (response.status === 201) 
    {
      return history.go(0);
    } 

    setMsgError(response.message)
    setError(true)
    setInProgress(false);

  }
   
const handleDateChange = (e) => {
  let value = e.target.value.replace(/\D/g, '');

  if (value.length > 2) {
    value = `${value.slice(0, 2)}/${value.slice(2)}`;
  }
  if (value.length > 5) {
    value = `${value.slice(0, 5)}/${value.slice(5)}`;
  }

  setFields({ ...fields, birthday: value });
};

  /* OUTROS CODIGOS */
  return (
    <FormWrapperForm>
      
      {(error)&& <Alert color="danger">{msgError}</Alert>}

      <Form onSubmit={create}>

        <Row form>

          <Col md={6}>
            <FormGroup>
               <span style={{
                display: 'block',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>
                Nome:
              </span>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <FontAwesomeIcon icon={faUser} />
                  </InputGroupText>
                </InputGroupAddon>

              <InputView
                required
                value={fields.name}
                placeholder="Nome"
                name="name"
                onChange={(e) => setFields({...fields, name: e.target.value})}
              />

              </InputGroup>
            </FormGroup>
          </Col>


         <Col md={6}>
            <FormGroup>
              <span style={{
                display: 'block',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>
                Nome da Mãe:
              </span>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <FontAwesomeIcon icon={faFemale} />
                  </InputGroupText>
                </InputGroupAddon>

                     <InputView
                      required
                      value={fields.mother_name}
                      placeholder="Nome da mãe"
                      name="motherName"
                       maxLength="120"
                      onChange={(e) => setFields({...fields, mother_name: e.target.value})}
                    />

              </InputGroup>
            </FormGroup>
          </Col>

        </Row>
         <Row form>

     
          <Col md={6}>
            <FormGroup>
              <span style={{
                display: 'block',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>
                Data de nascimento:
              </span>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <FontAwesomeIcon icon={faCalendar} />
                  </InputGroupText>
                </InputGroupAddon>
                      <InputView
                        required
                        value={fields.birthday}
                        placeholder="Data de Nascimento"
                        name="birthday"
                        maxLength="10"
                        onChange={handleDateChange}
                      />
              </InputGroup>
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <span style={{
                display: 'block',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>
                Cpf:
              </span>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <FontAwesomeIcon icon={faIdCard} />
                  </InputGroupText>
                </InputGroupAddon>

                      <InputView
                        required
                        value={fields.cpf}
                        placeholder="CPF"
                        maxLength="11"
                        name="cpf"
                        onChange={(e) => setFields({...fields, cpf: e.target.value})}
                      />

              </InputGroup>
            </FormGroup>
          </Col>

        </Row>
        <Row form>

     
          <Col md={6}>
            <FormGroup>
              <span style={{
                display: 'block',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>
                Telefone:
              </span>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <FontAwesomeIcon icon={faPhone} />
                  </InputGroupText>
                </InputGroupAddon>

                     <InputView
                      required
                      value={fields.tel}
                      placeholder="Telefone"
                      name="tel"
                      maxLength="13"
                      onChange={(e) => setFields({...fields, tel: e.target.value})}
                    />

              </InputGroup>
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <span style={{
                display: 'block',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>
                E-mail:
              </span>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <FontAwesomeIcon icon={faEnvelope} />
                  </InputGroupText>
                </InputGroupAddon>

                     <InputView
                      required
                      value={fields.email}
                      placeholder="E-mail"
                      name="email"
                      onChange={(e) => setFields({...fields, email: e.target.value})}
                    />

              </InputGroup>
            </FormGroup>
          </Col>

        </Row>
      

        <Row form>
            <Col md={12}>
          <FormGroup>
            <Label>
              Código de Paciente  
              <span
                id="Popover1"
                style={{ cursor: "pointer" }}
                onMouseEnter={abrirPopover}
                onMouseLeave={fecharPopover}
              >
                <FontAwesomeIcon style={{marginLeft: '3px'}} icon={faQuestionCircle} />
              </span>
            </Label>

            <Popover
              isOpen={popoverOpen}
              target="Popover1"
              toggle={() => {}}
              placement="right"
            >
              <PopoverBody>
                Cada paciente possui um código único. Ao informar o código do paciente
                neste campo, todos os exames vinculados a esse paciente serão exibidos
                quando ele acessar a página.
              </PopoverBody>
            </Popover>

                <InputGroup>
                      <InputView
                        required
                        value={fields.code_patient}
                        placeholder="Código do paciente"
                        name="code"
                        onChange={(e) => setFields({...fields, code_patient: e.target.value})}
                      />
                </InputGroup>
              </FormGroup>
              
             
            </Col>
          


        </Row>
        
        
          { (inProgress) ?
              <Spinner color="primary" />
            :
            <Button color="primary" type="submit">
              <FontAwesomeIcon icon={faWrench} /> Editar
            </Button>
          }
      </Form>

    </FormWrapperForm>
  );
}